import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8fb0de4a"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fb0de4a')) {
      api.createRecord('8fb0de4a', component.options)
    } else {
      api.reload('8fb0de4a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8fb0de4a", function () {
      api.rerender('8fb0de4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/smart-analytics/index.vue"
export default component.exports